<template><div class="main">
  <sticky-bar
      search="search unit names, fault texts, and POI names"
      v-model="search"
    >Inbox <template v-if="unreadCount > 0">({{unreadCount}})</template></sticky-bar>
  <div class="s">
    <div class="h">
      <button
          :class="{active:showNonCritical}"
          @click="showNonCritical=!showNonCritical">
        <span class="material-icons">
          {{ showNonCritical ? 'check_box' : 'check_box_outline_blank' }}
        </span>Show Non-Critical</button>
      <button
          :class="{active:showArchived}"
          @click="showArchived=!showArchived">
        <span class="material-icons">
          {{ showArchived ? 'check_box' : 'check_box_outline_blank' }}
        </span>Show Archived</button>
      <button
          :class="{active:direction==='down'}"
          @click="loadAlerts('down', true)">
        <span class="material-icons">publish</span>Newest</button>
      <button
          :class="{active:direction==='up'}"
          @click="loadAlerts('up', true)">
        Oldest<span class="material-icons">download</span></button>
      <button
          class="archive-all"
          @click="archiveAll">
        <span class="material-icons">done_all</span>Archive All</button>
      <button
          v-if="showArchived"
          class="dearchive-all"
          @click="dearchiveAll">
        <span class="material-icons">done_all</span>Dearchive All</button>
    </div>
    <div class="b" v-if="alerts && alerts.length">
      <div
          v-if="loading !== 'up'"
          class="loadnav"
          @click="loadAlerts('up')">
        <span class="material-icons">arrow_upward</span> Load more</div>
      <div v-else class="loadnav"><Loading /></div>
      <table class="alerts selectable">
      <tr
          v-for="alert in alerts"
          :key="`a-${alert.id}`"
          :class="{archived:alert.done}"
          @click="select(alert.id)">
        <td
            v-if="alert.critical"
            class="critical"
            title="Critical Fault">
          <span class="material-icons critical">flag</span></td>
        <td
            v-else
            class="critical"
            title="Advisory Fault">
          <span class="material-icons advisory">outlined_flag</span></td>
        <td class="unit" v-html="alert.unit" />
        <td class="details">
          <div class="info" v-html="alert.info" />
          <div v-if="alert.gps === null" class="no-gps">No Location Data</div>
          <div v-else><a
              target="_blank"
              :href="`https://www.google.com/maps?t=k&q=loc:${alert.gps[0]},${alert.gps[1]}`">
            <span class="gps-label">GPS: </span>
            <span class="gps-coords" v-html="renderCoords(alert.gps)" />
            <span class="pois" v-if="alert.pois.length > 0"> ({{alert.pois.join(', ')}})</span>
          </a></div>
          <alert-detail v-if="alert.id === selectedId" v-model="selectedId" />
        </td>
        <td class="archived"
            @click.stop="toggleArchived(alert)"
            :title="alert.done?'Archived':'Not Archived'">
          <Loading v-if="alert.archiving" />
          <span v-else-if="!alert.done" class="material-icons no">done</span>
          <span v-else class="material-icons yes">check_circle</span></td>
        <!--<td v-html="alert" />-->
      </tr>
      </table>
      <div
          v-if="loading !== 'down'"
          class="loadnav"
          @click="loadAlerts('down')"><span class="material-icons">arrow_downward</span> Load more</div>
      <div v-else class="loadnav"><Loading /></div>
    </div>
    <div class="empty" v-else-if="loading">
      <Loading /> Loading ...
    </div>
    <div class="empty" v-else>
      <p v-if="alerts">There are no alerts matching the selected criteria.</p>
      <button @click="loadAlerts()">Click here to refresh alerts</button>
    </div>
  </div>
</div></template>
<script>
import { mapState } from 'vuex'
import api from '../../api'
import AlertDetail from './AlertDetail'
import Loading from '../Loading'
import StickyBar from '../StickyBar'
export default {
  name: 'alerts',
  components: { AlertDetail, Loading, StickyBar },
  data() {
    return {
      showNonCritical: true,
      showArchived: false,
      alerts: null,
      loading: null,
      error: null,
      refs: [],
      search: null,
      direction: 'down',
      timeout: null,
      selectedId: null,
    }
  },
  computed: {
    ...mapState(['unreadCount']),
  },
  methods: {
    cancel() {
      for (const ref of this.refs) {
        ref.cancel()
      }
      this.refs = []
    },
    async loadAlerts(direction, refresh) {
      this.cancel()
      if (typeof(direction) === 'undefined') {
        direction = this.direction
        refresh = true
      }
      if (refresh) {
        this.loading = true
        this.direction = direction
        this.alerts = null
      } else {
        this.loading = direction
      }
      this.error = null
      let ref = { }
      this.refs.push(ref)
      if (this.search) ref.search = this.search
      if (!this.showNonCritical) ref.critical = true
      if (!this.showArchived) ref.done = false
      if (direction === 'down') {
        ref.newest = true
        if (this.alerts) ref.before = ['pk', this.alerts[this.alerts.length - 1].id]
      } else {
        ref.newest = false
        if (this.alerts) ref.after = ['pk', this.alerts[0].id]
      }
      try {
        let { alerts, unreadCount } = await api.getAlerts(ref)
        for (const a of alerts) a.archiving = false
        if (this.alerts === null)
          this.alerts = alerts
        else if (direction === 'down')
          this.alerts.push(...alerts)
        else
          this.alerts.splice(0, 0, ...alerts)
        this.$store.commit('setUnreadCount', unreadCount)
      } catch(e) {
        console.error(e)
        this.error = refresh ? true : direction
      } finally {
        let i = this.refs.indexOf(ref)
        if (i >= 0) {
          this.refs.splice(i, 1)
          this.loading = false
        }
      }
    },
    renderCoords(gps) {
      let lat = gps[0] >= 0 ? `${gps[0].toFixed(6)} N` : `${(-gps[0]).toFixed(6)} S`,
        lng = gps[1] >= 0 ? `${gps[1].toFixed(6)} E` : `${(-gps[1]).toFixed(6)} W`
      return `${lat}, ${lng}`
    },
    delayedLoad() {
      if (this.timeout !== null)
        clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.timeout = null
        this.loadAlerts()
      }, 250)
    },
    async toggleArchived(a) {
      if (a.archiving) return
      a.archiving = true
      let nv = !a.done
      let ref = { updates: { } }
      ref.updates[a.id] = { done: nv }
      this.refs.push(ref)
      try {
        let { unreadCount } = await api.updateAlerts(ref)
        a.done = nv
        this.$store.commit('setUnreadCount', unreadCount)
      } catch(e) {
        console.error(e)
        this.error = 'archive'
      } finally {
        let i = this.refs.indexOf(ref)
        if (i >= 0) this.refs.splice(i, 1)
        a.archiving = false
      }
    },
    archiveAll() {
      this.archiveAlertsBulk(true)
    },
    dearchiveAll() {
      this.archiveAlertsBulk(false)
    },
    async archiveAlertsBulk(newDone) {
      this.cancel()
      this.alerts = null
      this.loading = true
      this.error = null
      let ref = { newDone }
      this.refs.push(ref)
      if (this.search) ref.search = this.search
      if (!this.showNonCritical) ref.critical = true
      try {
        let n = await api.archiveAlertsBulk(ref)
        this.loadAlerts()
      } catch(e) {
        console.error(e)
        this.error = true
      } finally {
        let i = this.refs.indexOf(ref)
        if (i >= 0) {
          this.refs.splice(i, 1)
          this.loading = false
        }
      }
    },
    select(id) {
      this.selectedId = (this.selectedId !== id) ? id : null
    },
  },
  watch: {
    showNonCritical() { this.loadAlerts() },
    showArchived() { this.loadAlerts() },
    search(nv, ov) {
      if (!nv && !ov) return
      this.delayedLoad()
    },
  },
  activated() { this.loadAlerts() },
  created() { this.loadAlerts() },
}
</script>
<style lang="scss" scoped>
.main {
  overflow: hidden;
  .s {
    overflow: auto;
  }
  .h {
    background: #aaa;
    position: sticky;
    top: 0;
    padding: 5px 20px;
    overflow-x: auto;
    white-space: nowrap;
  }
  .b {
    padding: 0 20px;
    background: #fff;
  }
  .loadnav {
    text-align: center;
    background: #ddd;
    display: block;
    margin: 0 -20px;
    padding: 10px 0;
    cursor: pointer;
    &:hover { background: #eee; }
  }
  .material-icons {
    vertical-align: bottom;
    font-size: 1.2em;
    margin-right: 5px;
  }
  button:not(:first-child) { margin-left: 5px; }
  button.active { background: #fff; }
  .dearchive-all .material-icons { color: #a00; }
  .archive-all .material-icons { color: #080; }
  .empty {
    padding: 20px;
  }
  .loading {
    vertical-align: middle;
    margin-right: 10px;
  }
  .critical { color: #f00; }
  .advisory { color: #cc0; }
  .alerts {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
    tr.archived td { background: #eee; }
    .material-icons { font-size: 36px; margin-right: 0; }
    td {
      border-bottom: 1px solid #aaa;
      padding: 10px 0;
    }
    tr {
      cursor: default;
      &:hover { td { background-color: #ddd !important; } }
    }
    tr > .critical { padding: 0 10px 0 5px; }
    .unit { white-space: nowrap; }
    .no-gps { font-style: italic; }
    .gps-label { font-style: italic; }
    .details { width: 100%; padding: 10px 20px; a:not(:hover) { text-decoration: none; } }
    td.archived { padding: 0 5px 0 10px; cursor: pointer; }
    td.archived .no { color: #888; font-weight: bold; }
    td.archived .yes { color: #060; }
  }
}
</style>
